import { Component, inject, input } from '@angular/core';
import { MatButton } from '@angular/material/button';

import { AuthStore } from '../../state/auth.store';
// import { FacebookIconComponent } from './icons/facebook-icon.component';
import { GoogleIconComponent } from './icons/google-icon.component';

@Component({
  selector: 'r2e-sign-in-providers',
  imports: [MatButton, GoogleIconComponent],
  templateUrl: './sign-in-providers.component.html',
  styleUrl: './sign-in-providers.component.scss',
})
export class SignInProvidersComponent {
  private authStore = inject(AuthStore);

  disabled = input<boolean>(false);
  marketingConsent = input<boolean>(false);

  signInWithFacebook() {
    this.authStore.signInWithFacebook();
  }

  signInWithGoogle() {
    this.authStore.signInWithGoogle(this.marketingConsent());
  }
}
